<template>
  <div>
    <v-app-bar height=80 elevation="0" clipped-left fixed app style="border-bottom: 1px solid lightgray; background-color: #f5f5f5; top: var(--safe-area-inset-top);">
      <img v-show="!isMobile" class="ml-4 mr-1" :src="require('../../public/assets/logo.png')" height="35" />
      <v-toolbar-title v-show="!isMobile">{{ $route.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title style="margin-right: 0.5rem" v-if="validUser" v-show="!isMobile">{{ clientName }}</v-toolbar-title>

      <CallBar v-if="validUser" style="height: 65px" />

      <!-- Warning icon shown when OD connector is offline -->
      <v-tooltip v-if="odConnectorStatus === 'offline'" location="bottom" bottom>
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" color="warning" class="ml-4">
            mdi-alert-circle
          </v-icon>
        </template>
        <span v-if="isAdmin">DSS OD Connector is offline. Please configure the connector agent.</span>
        <span v-else>DSS OD Connector is offline. Please contact the administrator.</span>
      </v-tooltip>
      <v-tooltip  v-if="failedJobs" location="bottom" bottom interactive>
        <template v-slot:activator="{ props }">
          <v-icon v-bind="props" color="warning" class="ml-4">
           mdi-progress-alert
          </v-icon>
        </template>
       <span v-if="isAdmin">Task Engine Job has failed. Please check</span>
      <span v-else>Task Engine Job has failed. Please contact the administrator.</span>
      </v-tooltip>
      
      <AudioSettings v-if="validUser" />

      <!-- right navbar stuff -->
      <div v-if="validUser">
        <v-app-bar-nav-icon>
          <v-menu offset-y>
            <template v-slot:activator="{ props }">
              <v-btn v-bind="props" icon>
                <v-avatar v-bind:color="hashedColor(username)" size="40">
                  <span class="text-white">{{ userInitials }}</span>
                </v-avatar>
              </v-btn>
            </template>
            <v-card>
              <div class="justify-center mx-2 mt-2">
                <div class="mx-auto text-center py-2">
                  <v-avatar v-bind:color="hashedColor(username)" size="40">
                    <span class="text-white">{{ userInitials }}</span>
                  </v-avatar>
                  <br />
                  <br />
                  <h4>{{ username }}</h4>
                  <p class="caption mt-1">
                    {{ email }}
                  </p>
                  <v-divider class="my-3"></v-divider>
                  <v-btn variant="plain" @click="profileDialog = true" text>
                    Profile
                    <v-icon right> mdi-account </v-icon>
                  </v-btn>
                  <v-divider class="my-3"></v-divider>
                  <v-btn variant="plain" v-if="isAdmin" @click="adminDialog = true" text>
                    Admin
                    <v-icon right> mdi-account-supervisor </v-icon>
                  </v-btn>
                  <v-divider v-if="isAdmin" class="my-3"></v-divider>
          
                  <span v-if ="isAdmin && !this.is_loading" >
                    <v-btn v-if="this.is_subscribed" variant="plain" @click="redirectTosubscribed" text>
                      View Plan
                      <v-icon right>mdi-currency-usd</v-icon>
                    </v-btn>
                    <v-btn v-else variant="plain" @click="redirectToPricing" text>
                      Subscribe
                      <v-icon right>mdi-currency-usd</v-icon>
                    </v-btn>
                  </span>
                  <v-divider v-if="isAdmin" class="my-3"></v-divider>
                  <span v-if ="isAdmin && this.clientId=='1'" >
                    <v-btn variant="plain" @click="redirectToPriceManagementPage" text>
                      Price Management
                      <v-icon right>mdi-currency-usd</v-icon>
                    </v-btn>
                    <v-divider v-if="isAdmin" class="my-3"></v-divider>
                  </span>
                  
                  <v-btn variant="plain" @click="settingsDialog = true" text>
                    Settings
                    <v-icon right> mdi-cog </v-icon>
                  </v-btn>
                  <v-divider class="my-3"></v-divider>
                  <v-btn variant="plain" @click="logOut" text>
                    Logout
                    <v-icon right> mdi-logout-variant </v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-menu>
        </v-app-bar-nav-icon>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-if="validUser && !isMobile" permanent expand-on-hover rail app>
      <v-list dense>
        <v-list-item
          :class="{ highlighted: $route.path === item.route }"
          v-for="item in this.navbarItems"
          :key="item.title"
          :to="item.route"
          :title="item.title"  
        >
          <template v-slot:prepend>
            <v-icon :color="$route.path === item.route ? 'blue' : ''">{{ item.icon }}</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-bottom-navigation v-if="validUser && isMobile && showBottomNav" grow class="safe-bottom-nav" style="height: 56px; bottom: var(--safe-area-inset-bottom);">
      <v-btn v-for="item in this.navbarItems" :key="item.title" :to="item.route" :title="item.title" color="primary"
      active>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-dialog :persistent="profileDialogPersist" v-model="profileDialog" max-width="500">
      <ProfileDialog v-if="profileDialog == true" @editStatus="profileDialogEvent" />
    </v-dialog>
    <v-dialog v-model="settingsDialog" max-width="500">
      <SettingsDialog v-if="settingsDialog == true" />
    </v-dialog>
    <v-dialog v-model="adminDialog" max-width="500">
      <AdminDialog v-if="adminDialog == true" />
    </v-dialog>
  </div>
</template>

<script>
import colorMixin from "@/mixins/colorMixin";
import CallBar from "@/components/CallBar/CallBar";
import AudioSettings from "@/components/AudioSettings";
import AdminDialog from "@/components/AdminDialog";
import ProfileDialog from "@/components/ProfileDialog";
import SettingsDialog from "@/components/SettingsDialog";
import AdminService from "@/services/adminService";
import router from "@/router";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import { mapState } from 'vuex'
import featureFlags from "@/featureFlags";

export default {
  name: "Navbar",
  components: {
    CallBar,
    AdminDialog,
    ProfileDialog,
    SettingsDialog,
    AudioSettings,
  },
  mixins: [colorMixin],
  props: {
    items: { type: Array, default: () => [] },
  },
  data() {
    return {
      is_subscribed: null,
      is_loading: true,
      callingBarInput: null,
      validNumber: false,
      adminDialog: false,
      profileDialog: false,
      profileDialogPersist: false, // if this is true, then you can't click out of the profile dialog
      settingsDialog: false,
      clientOnboardingDialog: false,
      routeName: "",
    };
  },
  computed: {
    ...mapGetters(["loggedIn", "username", "userInitials", "email", "clientName", "clientId","isAdmin", "isODEnabled"]),
    ...mapState(["validUser"]),
    ...mapGetters("window", ["isMobile","showBottomNav"]),
    ...mapGetters('odconnector', { odConnectorStatus: 'status'}),
    ...mapGetters("taskengine", ["failedJobs"]),
    navbarItems() {
      return this.getItems();
    },
  },
  async beforeMount() {
    try{
      const response = await AdminService.getSubscriptionDetails();
      this.is_subscribed = response.data.is_subscribed;
    }catch(err){
      console.log('error retrieving subscription details',err);
    }
    finally{
      this.is_loading=false;
    }
  },
  async created() {
    const response = await AdminService.getSubscriptionDetails();
    this.is_subscribed = response.data.is_subscribed;
    this.checkIsODEnabled();
  },
    methods: {
    ...mapActions(["logOut", "checkIsODEnabled"]),
    routeChanged(item) {
      if (this.$route.path !== item.route) this.$router.push({ path: item.route });
    },
    profileDialogEvent(editingOn) {
      this.profileDialogPersist = editingOn;
    },
    checkAdminClientName() {
      return !!this.clientId && this.clientId == 1;
    },
    getItems() {
      // adding icons to the left panel
      const items = [...this.items];
      items.push({ title: "Sales Workflow", route: "/frontdesk", icon: "mdi-monitor" });
      if(this.isODEnabled){
        items.push({ title: "Outstanding Claims Workflow", route: "/osclaims", icon: "mdi-currency-usd" });
        items.push({ title: "Lab Cases", route: "/labCases", icon: "mdi-flask" });
      }
      items.push({ title: "General Conversation", route: "/conversation", icon: "mdi-chat" });
      items.push({ title: "Calendar", route: "/calendar", icon: "mdi-calendar-account-outline" });
      
      // Add IVR Management only if feature flag is enabled
      if (featureFlags.isEnabled('IVR_PLUGIN')) {
        items.push({ title: "IVR Management", route: "/ivr-management", icon: "mdi-phone-settings" });
      }
      
      if (this.isAdmin) {
        if (this.checkAdminClientName()) {
          items.push({ title: "AI Agents", route: "/aiAgents", icon: "mdi-brain" }); 
          items.push({ title: "Client List", route: "/clientlist", icon: "mdi-account" });
        } else {
          items.push({ title: "Settings", route :`/settings`, icon :"mdi-cog-outline"});
          items.push({ title: "Automations", route :`/automations`, icon :"mdi-auto-mode"});
        }
      }
      return items;
    },
    redirectToPricing() {
      this.$router.push(`/pricing`);
    },
    redirectTosubscribed(){
      this.$router.push(`/subscriptionManagement`);      
    },
    redirectToPriceManagementPage(){
      this.$router.push(`/priceManagement`);
    }
  },
};
</script>